._thumb_khbg4_1 {
  background-color: #f1f8ff;
  border: 1px solid #ebecef;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 120px;
  max-height: 200px; }

._thumb-img_khbg4_12 {
  pointer-events: none;
  max-height: 200px;
  object-fit: contain;
  align-self: center;
  max-width: 100%;
  height: auto; }
